import React from 'react';
import { connect } from 'react-redux';
import { push } from 'react-router-redux';
import { Input as _Input, Form as _Form, Icon } from 'antd';
import styled from 'styled-components';
import { compose, withProps } from 'recompose';

import { actions as authActions } from 'modules/auth';
import { redirectIfLoggedIn } from 'utils/HOCs/redirect';
import { BlueButton } from 'components/Core/Buttons';

const Container = styled.div`
  display: flex;
  height: 100vh;
  justify-content: center;
  align-items: center;
`;

const FormContainer = styled(_Form)`
  width: 350px;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const Input = styled(_Input)`

`;

const TmtLogo = styled.img`
  width: 150px;
  margin-bottom: 8px;
`;

const Title = styled.h1`

`;

const FormItem = styled(_Form.Item)`
  width: 100%;
  margin-bottom: 10px !important;
`;

const enhance = compose(
  redirectIfLoggedIn,
  connect(
    null,
    { ...authActions, push }
  ),
  _Form.create(),
  withProps(
    ownProps => ({
      handleLogin: (e) => {
        e.preventDefault();
        ownProps.form.validateFields(async (err, loginData) => {
          if (!err) {
            await ownProps.login(loginData);
            ownProps.push('/product');
          }
        });
      }
    })
  )
);

const Login = props => {
  const { getFieldDecorator } = props.form;
  return (
    <Container>
      <FormContainer onSubmit={props.handleLogin}>
        <TmtLogo src={require('images/tmt-logo.png')} alt="branding" />
        <Title>TakeMeTour Partner</Title>
        <FormItem>
          {getFieldDecorator('email', {
            rules: [{ required: true, type: 'email', message: 'Please input your email!' }],
          })(
            <Input prefix={<Icon type="user" style={{ fontSize: 13 }} />} placeholder="Email" />
          )}
        </FormItem>
        <FormItem>
          {getFieldDecorator('password', {
            rules: [{ required: true, message: 'Please input your Password!' }],
          })(
            <Input prefix={<Icon type="lock" style={{ fontSize: 13 }} />} type="password" placeholder="Password" />
          )}
        </FormItem>
        <FormItem>
          <BlueButton htmlType="submit">Login</BlueButton>
        </FormItem>
      </FormContainer>
    </Container>
  );
};

export default enhance(Login);



// WEBPACK FOOTER //
// ./src/pages/Auth/Login.js